export function deleteArray(arr, index) {
  arr.splice(index, 1)
  return arr
}

export function findArrayIndex(arr, list, idName) {
  let index = arr.findIndex((item) => {
    return item[idName] === list[idName]
  })
  return index
}

function param(data) {
  let url = ''
  for (let k in data) {
    let value = data[k] !== undefined ? data[k] : ''
    url += `&${k}=${encodeURIComponent(value)}`
  }
  return url ? url.substring(1) : ''
}

export function formatUrl(url, data) {
  let linkUrl = url + (url.indexOf('?') < 0 ? '?' : '&') + param(data)
  return linkUrl
}

export function deepClone(obj) {
  let result
  let oClass = isClass(obj)
  if (oClass === 'Object') {
    result = {}
  } else if (oClass === 'Array') {
    result = []
  } else {
    return obj
  }
  for (let key in obj) {
    let copy = obj[key]
    if (isClass(copy) == 'Object') {
      result[key] = arguments.callee(copy)
    } else if (isClass(copy) == 'Array') {
      result[key] = arguments.callee(copy)
    } else {
      result[key] = obj[key]
    }
  }
  return result
}

export function norlizeColumns(columnKeys, columnsMaps) {
  let columns = []
  for (let columnName of columnKeys) {
    let c = columnName.split(',')
    if (c[0] === 'index' || c[0] === 'selection') {
      columns.push({
        sequence: c[0],
        label: c[0] === 'index' ? '序号' : '',
        width: parseInt(String(c[1]).trim())
      })
    } else if (c[0] === 'image') {
      columns.push({
        image: true,
        prop: c[1].trim(),
        label: columnsMaps.get(c[1].trim()),
        width: parseInt(c[2]) || 'auto'
      })
    } else {
      let cf = {
        prop: c[0],
        width: parseInt(c[1]) || 'auto'
      }
      let v1 = columnsMaps.get(c[0])
      if (v1 instanceof Object) {
        for(let key in v1){
          cf[key] = v1[key];
        }
        if (v1.category && v1.category === 'color') {
          cf.color = true
          cf.rgb = v1.rgb || 'blue'
        }
      } else {
        cf.label = v1
      }
      columns.push(cf)
    }
  }
  return columns
}

function FormatDate(fmt, date) {
  let o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds(),
    'q+': Math.floor((date.getMonth() + 3) / 3),
    'S': date.getMilliseconds()
  }
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  for (let k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
    }
  }

  return fmt
}

export function transformDate(format, value) {
  if (!value) return
  return FormatDate(format, new Date(value))
}

export function dateMinus1(value) {
  if (!value) {
    return ''
  }
  let dateTime = new Date(value)
  dateTime = new Date(dateTime.setDate(dateTime.getDate() - 1))
  return FormatDate('yyyy-MM-dd hh:mm:ss', dateTime)
}
export function dateFormat(value) {
  if (!value) {
    return ''
  }
  let dateTime = new Date(value)
  dateTime = new Date(dateTime.setDate(dateTime.getDate()))
  return FormatDate('yyyy-MM-dd', dateTime)
}

export function dateAddDay(value,num){
  if(!value){
    return ''
  }
  let dateTime = new Date(value)
  dateTime = new Date(dateTime.setDate(dateTime.getDate() + num))
  return FormatDate('yyyy-MM-dd', dateTime)
}

export function toFixed(num, s) {
  var times = Math.pow(10, s)
  var des = num * times + 0.5
  des = parseInt(des, 10) / times
  return des + ''
}

/***
 * 构建目录树
 * @param array router/index.js 里配置的路由
 * @param ckey
 * @returns {[]|*[]}
 */
export function buildTree(array, ckey) {
  // console.log('路由',array,ckey)
  if (array.length === 0) {
    return []
  }
  let menuData = []
  let mkey = 'id'
  // 判断是否是数组，如果是数组则返回 id 数组，否则返回空数组
  let indexKeys = Array.isArray(array) ? array.map((e) => {
    return e[mkey]
  }) : []
  //如果ckey 不为空，则取前面的，否则取后面的
  ckey = ckey || 'parentId'
  array.forEach(function (e, i) {
    if (!e[ckey] || (e[ckey] === e[mkey])) {
      //如果为空或id相同则删除
      delete e[ckey]
      menuData.push(deepcopy(e))
    } else if (Array.isArray(indexKeys)) {
      //todo 查找出id为0的索引，但是这里是通过比较两个for循环来遍历 id!=parentId,来拿到索引的，效率感觉低啊
      // if(e['id']==0){
      //  menuData.push(e)
      // }
      // 这样子是否快一点

      //获取一级菜单索引
      let parentIndex = indexKeys.findIndex(function (id) {
        return id == e[ckey]
      })
      if (parentIndex === -1) {
        //将菜单添加到表中去
        menuData.push(e)
      }
    }
  })
  /***
   * 查找并添加子菜单到一级菜单中去
   * @param parentArr
   */
  let findChildren = function (parentArr) {
    if (Array.isArray(parentArr) && parentArr.length) {
      parentArr.forEach(function (parentNode) {
        array.forEach(function (node) {
          if (parentNode[mkey] === node[ckey]) {
            if (parentNode.children) {
              parentNode.children.push(node)
            } else {
              parentNode.children = [node]
            }
          }
        })
        if (parentNode.children) {
          findChildren(parentNode.children)
        }
      })
    }
  }
  findChildren(menuData)
  // console.dir(menuData)
  return menuData
}

/**
 *
 * @param source
 * @returns {[]|{}|*}
 */
function deepcopy(source) {
  if (!source) {
    return source
  }
  console.log("source:" + source)
  let sourceCopy = source instanceof Array ? [] : {}
  for (let item in source) {
    sourceCopy[item] = typeof source[item] === 'object' ? deepcopy(source[item]) : source[item]
  }
  return sourceCopy
}

export function normalizeObj(oldObj) {
  let obj = {
    ...oldObj
  }
  if (!(typeof obj == 'object')) {
    return false
  }
  for (let key in obj) {
    if (obj.hasOwnProperty(key) && (obj[key] == null || obj[key] == undefined || obj[key] == '')) {
      delete obj[key]
    }
  }
  return obj
}

export function _sort(keyName) {
  return function (objectN, objectM) {
    let valueN = objectN[keyName]
    let valueM = objectM[keyName]
    if (valueN < valueM) {
      return -1
    } else if (valueN > valueM) {
      return 1
    } else {
      return 0
    }
  }
}

export function corSubjects(majors, subjects) {
  if (majors.length && subjects.length) {
    subjects.map(subject => {
      if (subject.professionId) {
        majors.map(major => {
          if (major.id && major.id === subject.professionId) {
            subject.name = major.name + '/' + subject.name
          }
        })
      }
    })
    return subjects
  }
}

export function forSelectTmpl(arr, label, value) {
  if (!arr.length) {
    return []
  } else {
    arr.map(item => {
      item.label = item[label]
      item.value = item[value]
    })
  }
  return arr
}

export function abcdList(a, i) {
  let str = a
  return String.fromCharCode(str.charCodeAt() + i)
}

// 获取uuid
export function uuid() {
  var s = [];
  var hexDigits = "0123456789abcdef";
  for (var i = 0; i < 36; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
  }
  s[14] = "4";  // bits 12-15 of the time_hi_and_version field to 0010
  s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);  // bits 6-7 of the clock_seq_hi_and_reserved to 01
  s[8] = s[13] = s[18] = s[23] = "-";

  var uuid = s.join("");
  let reg = new RegExp('-', 'g')//g代表全部
  return uuid.replace(reg, '');
}



// WEBPACK FOOTER //
// ./src/utils/handle.js